import Loading from '../../../../../components/general/loadings/loading';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import { Accordion } from '../../../../../components/general/accordion';
import { AlertsSectionProps } from './props';
import { useAlertsSection } from './hook';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const AlertsSection = ({
    alertSection,
    loading,
}: AlertsSectionProps) => {
    const { formik } = useAlertsSection(alertSection);

    return loading ? (
        <Loading />
    ) : (
        <Accordion
            title="EJECUCIÓN"
            icon={<PermPhoneMsgIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={true}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Fecha"
                        name="alertDate"
                        size="small"
                        value={formik.values.alertDate}
                        onChange={console.log}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Clasificación"
                        name="classification"
                        size="small"
                        value={formik.values.classification}
                        onChange={console.log}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Número de días"
                        name="numberDays"
                        size="small"
                        value={formik.values.numberDays}
                        onChange={console.log}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Checkbox
                        label="Alerta por correo"
                        checked={Boolean(formik.values.alertByMail)}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
